import '@drf-ui/drf-nav-ssr/dist/index.css'; // Old Header and Left Rail CSS
import React, { Suspense, lazy } from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { WithAppConfig, LoadGoogleReCaptchaEnterpriseScript } from '@drf-ui/drf-app-config';
import Settings from '../config/settings';
import { StoryblokSiteConfigProvider } from '@drf-ui/drf-storyblok-app-config'; // Storyblok provider
import { Toaster } from 'react-hot-toast';

import ElasticHOC from './common/ElasticHOC';
import { CombinedStaticDataProvider } from '../utils/CombinedStaticDataContext';
import { ReloadNavProvider } from '../utils/ReloadNavContext';

const MemberCenterWrapper = lazy(() => import('./member-center/MemberCenterWrapper'));

const appEnv = Settings?.APP_ENV || 'production';

const AppRoutes = (props) => {
  const { combinedStaticData, useCommonStaticData } = props;

  {
    /*
     * GoogleReCaptchaProvider's responsibility is to load the necessary reCaptcha script and provide access to reCaptcha to the rest of your application.
     * Usually, your application only needs one provider.
     * You should place it as high as possible in your React tree.
     * It's to make sure you only have one instance of Google Recaptcha per page and it doesn't reload unecessarily when your components re-rendered.
     */
  }
  LoadGoogleReCaptchaEnterpriseScript(
    combinedStaticData?.data?.appConfig?.reCaptchaEnterpriseScriptURL,
    true,
    false,
    true
  );

  return (
    <Suspense fallback={<></>}>
      <Toaster position="top-right" />
      {/* for toaster not overlapping nav  */}
      {/* <Toaster 
        position="top-right"
        containerStyle={{
          top: '80px',
        }}
      /> */}
      <CombinedStaticDataProvider
        value={{ useCommonStaticData: useCommonStaticData, combinedStaticData: combinedStaticData?.data }}
      >
        <ReloadNavProvider>
          <StoryblokSiteConfigProvider appEnv={appEnv}>
            <Router>
              <Switch>
                <Route
                  path="/"
                  component={MemberCenterWrapper}
                />
              </Switch>
            </Router>
          </StoryblokSiteConfigProvider>
        </ReloadNavProvider>
      </CombinedStaticDataProvider>
    </Suspense>
  );
};

export default ElasticHOC(WithAppConfig(AppRoutes));
